// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";

import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyCHHXU6Wo-VP1c7Z5_UyOZjgzP9XAYIvTo",
  authDomain: "ncpwheels.firebaseapp.com",
  projectId: "ncpwheels",
  storageBucket: "ncpwheels.firebasestorage.app",
  messagingSenderId: "118010932830",
  appId: "1:118010932830:web:aa4c3715456722aa68cecf",
  measurementId: "G-GGGYD0S952"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);